export default __webpack_public_path__ + "static/media/fundamentos-fap-responsivo.b8806cfa.png";